// ResponsiveInfoButton.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import media, { hover } from '../style/media.js';

import { NULL_FUNCTION, EMPTY_OBJECT } from '../resource/defaults.js';

const ResponsiveInfoButton = ({
  articleUrl = '',
  modalId = '',
  modalHeaderTitle = '',
  toggleModal = NULL_FUNCTION,
  trackingModalId = '',
  trackingPayload = EMPTY_OBJECT,
  children = null,
  className = '',
  onClick = NULL_FUNCTION,
}) => {
  const handleModalClick = event => {
    event.preventDefault();
    toggleModal({
      modalId,
      payload: {
        articleUrl,
        headerTitle: modalHeaderTitle,
      },
      isOpen: true,
      modalOption: {
        isHigherThanAll: true,
      },
    });
    onClick(event);
  };

  const commonProps = {
    href: articleUrl,
    className,
    'data-element_id': trackingModalId,
    'data-tracking_payload': trackingPayload,
  };

  const desktopProps = {
    ...commonProps,
    href: `/iframe?source=${encodeURIComponent(articleUrl)}`,
  };

  return (
    <LinkWrapper>
      <ModalLink {...commonProps} onClick={handleModalClick}>
        {children}
      </ModalLink>
      <NewTabLink {...desktopProps} onClick={onClick}>
        {children}
      </NewTabLink>
    </LinkWrapper>
  );
};

ResponsiveInfoButton.propTypes = {
  articleUrl: PropTypes.string.isRequired,
  modalId: PropTypes.string.isRequired,
  modalHeaderTitle: PropTypes.string.isRequired,
  toggleModal: PropTypes.func.isRequired,
  trackingModalId: PropTypes.string,
  trackingPayload: PropTypes.object,
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

const LinkWrapper = styled.div`
  width: 100%;
`;

const BaseLink = styled.a`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: inherit;
  cursor: pointer;

  ${hover`
    text-decoration: none;
    color: inherit;
    opacity: 1;
  `}
`;

const ModalLink = styled(BaseLink)`
  display: none;

  ${media.tablet`
    display: flex;
  `}
`;

const NewTabLink = styled(BaseLink)`
  ${media.tablet`
    display: none;
  `}
`;

export default ResponsiveInfoButton;
